module.exports = __webpack_public_path__ + "047977bae578eaff022e03761f9da1be.pdf";